export default __webpack_public_path__ + "static/media/play.98254cca.svg";